package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class NameOverrideRequest(
    @SerialName("name_en_override") val nameEnOverride: String? = null,
    @SerialName("name_ar_override") val nameArOverride: String? = null
)
